<template>
  <div>

    <v-container grid-list-lg fluid :class="{'mobile-card': $vuetify.breakpoint.xsOnly}"
                 :is="$vuetify.breakpoint.xsOnly ? 'div' : 'v-container'" style="background: white"
                 class="elevation-7 remove-space-on-print">

      <v-flex xs12 :class="{'logo-mobile': $vuetify.breakpoint.xsOnly, 'hide-on-print': true}"
              v-if="$vuetify.breakpoint.xsOnly">
        <img src="../../assets/logotj.png" style="margin-top: 5px;">
        <p><b>Consulta Pública de Atos e Selos</b></p>
      </v-flex>

      <v-flex xs12 v-else class="hide-on-print">
        <img src="../../assets/LogoTJROD.png">
      </v-flex>

      <v-layout row wrap v-if="selo" class="remove-space-on-print">

        <v-flex xs12 class="show-on-print">
          <div style="width: 124px;" class="pt-2">
            <img alt="Logo do Tribunal de Justiçã do estado de Rondônia" src="../../assets/logotj.png"
                 style="width: 100%">
          </div>
          <v-flex pl-4>
            <p class="subheading font-weight-thin text-uppercase mb-1 mt-2">Poder Judiciário do estado de Rondônia</p>
            <p class="subheading font-weight-thin text-uppercase mb-1">Tribunal de justiça</p>
            <p class="subheading font-weight-thin text-uppercase mb-1">Corregedoria geral da justiça</p>
          </v-flex>
        </v-flex>

        <v-flex xs12 class="show-on-print justify-center">
          <p class="subheading text-uppercase">Consulta pública de selos e atos</p>
        </v-flex>

        <v-flex lg12 class="remove-shadow-on-print">
          <dados-selo-card :selo="selo"></dados-selo-card>
        </v-flex>

        <v-flex lg12 class="remove-shadow-on-print">
          <dados-ato-card v-if="selo.atoMovimento" :selo="selo"/>
        </v-flex>

        <v-flex xs12 lg12 class="remove-shadow-on-print">
          <valor-pago-serventia v-if="selo.valorSeloAto" :valor="selo.valorSeloAto"></valor-pago-serventia>
        </v-flex>

        <v-flex xs12 lg12 class="remove-shadow-on-print">
          <dados-serventia-card v-if="selo.serventia" :serventia="selo.serventia"></dados-serventia-card>
        </v-flex>

        <v-flex xs12 lg12 class="remove-shadow-on-print show-on-print">
          <p>A aceitação deste documento está condicionada à verificação de sua autenticidade através do QR Code ou em {{url}}</p>
        </v-flex>

        <v-flex xs12 class="hide-on-print">
          <alerta-divergencia></alerta-divergencia>
        </v-flex>

        <v-flex xs12 class="hide-on-print">
          <v-btn block class="info nova-consulta-btn elevation-7" large @click="novaConsulta">Nova Consulta</v-btn>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
  import DadosSeloCard from './DadosSeloCard';
  import DadosServentiaCard from './DadosServentiaCard';
  import AlertaDivergencia from './AlertaDivergencia';
  import SeloService from "../../domain/selo/selo-service";
  import ValorPagoServentiaCard from './ValorPagoServentiaCard';
  import DadosAtoCard from "./DadosAtoCard";


  export default {
    components: {
      'dados-selo-card': DadosSeloCard,
      'dados-ato-card': DadosAtoCard,
      'dados-serventia-card': DadosServentiaCard,
      'alerta-divergencia': AlertaDivergencia,
      'valor-pago-serventia': ValorPagoServentiaCard
    },
    props: ['preloadedSelo'],
    data: function () {
      return {
        requesting: true,
        codigo: this.$route.query.codigo,
        tipo: this.$route.query.tipo,
        hash: this.$route.query.h,
        selo: undefined,
        serventia: undefined,
        url: window.location.origin
      };
    },
    created: function () {
      this.service = new SeloService(this.$resource);
      const {codigo, hash, tipo} = this.$route.query;

      if (this.$props.preloadedSelo) {
        this.selo = this.$props.preloadedSelo;
        this.requesting = false;
      } else if (hash)
        this.renderSelo(this.service.buscarPorHash(codigo, hash));
      else if (tipo)
        this.renderSelo(this.service.buscarPorTipo(codigo, tipo));
      else {
        this.notify.error(this, 'Parâmetros incorretos', 'Erro', 7000);
        return this.novaConsulta();
      }
    },
    methods: {
      renderSelo(promise) {
        let self = this;
        promise.then(selo => {
          self.selo = selo;
        }).catch(e => {
          let message = e.message || 'Não foi possível acessar o servidor';
          self.notify.error(self, message, 'Erro de conexão', 7000);
        }).finally(() => {
          self.requesting = false;
        });
      },
      novaConsulta() {
        this.$router.push({name: 'ConsultaSelo'});
      }
    }
  }
</script>

<style scoped>
  .nova-consulta-btn {
    margin: 0 auto 15px auto;
  }

  .logo-mobile {
    text-align: center;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/detalhes/Detalhes.vue